var _style, _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGravityLoaderPositive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "evavrakr0scm1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 280",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes evavrakr0scm3_tr__tr{0%{transform:translate(139.842741px,139.583679px) rotate(0deg)}to{transform:translate(139.842741px,139.583679px) rotate(-359.99deg)}}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "evavrakr0scm2",
    d: "M133.5 13.5c-66.274 0-120 53.726-120 120s53.726 120 120 120 120-53.726 120-120-53.726-120-120-120Zm0 2.846c64.702 0 117.154 52.452 117.154 117.154S198.202 250.654 133.5 250.654 16.346 198.202 16.346 133.5 68.798 16.346 133.5 16.346Z",
    transform: "translate(6.5 6.5)",
    fill: "#C4C7D6",
    stroke: "none",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(.01 -799685.646 801309.675)",
    style: {
      animation: "evavrakr0scm3_tr__tr 3000ms linear infinite reverse forwards"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "evavrakr0scm3",
    r: 16,
    transform: "translate(0 -118)",
    fill: "#04DEAD",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "evavrakr0scm4",
    d: "M102.966 64.07c41.936-20.454 92.512-3.04 112.965 38.896 20.453 41.936 3.038 92.512-38.897 112.965-41.936 20.453-92.512 3.038-112.965-38.897-20.453-41.936-3.038-92.512 38.897-112.965Zm5.207 70.196c1.62 15.42 12.867 24.795 26.823 23.328 5.855-.616 10.715-3.198 12.641-6.46l.39-.04.063 1.411 1.235 11.871-20.787 2.185 1.55 14.736 37.474-3.939-7.703-73.29-15.517 1.63.205 1.952c.144 1.366.334 2.234.503 2.907l-.39.041c-3.554-3.77-9.07-5.558-15.609-4.871-13.663 1.436-22.52 12.924-20.878 28.539Zm26.33-14.213c6.246-.657 11.1 3.273 11.807 10.007.708 6.734-3.212 11.685-9.457 12.341-6.149.646-11.002-3.284-11.72-10.115-.708-6.734 3.222-11.587 9.37-12.233Z",
    fill: "#000421",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGravityLoaderPositive);
export default __webpack_public_path__ + "static/media/gravity-loader-positive.f1e9f076faa3d956c2fa18243da92a33.svg";
export { ForwardRef as ReactComponent };